export enum ResultsVisibilityType {
  REAL_TIME = "REAL_TIME",
  DONT_SHARE = "DONT_SHARE",
  AFTER_CLOSED = "AFTER_CLOSED",
}
